import React, { useRef } from "react";

import { Button, Icon } from "semantic-ui-react";
import { t } from "i18next";
import useTheme from "../../../../hooks/useTheme";
import { useResponsive } from "../../../UI/ResponsiveContext";
import AppText from "../../../UI/Texts/AppTexts";
import JobCard from "../../JobListingsPage/Components/JobCard";

export function RelatedJobsSection({ allRelatedJobs = [] }) {
  const theme = useTheme();
  const scrollContainerRef = useRef(null);
  const { isMobile } = useResponsive();

  const scroll = (direction) => {
    scrollContainerRef.current?.scrollBy({
      left: direction * (isMobile ? 330 : 560),
      behavior: "smooth",
    });
  };

  const cardWidth = isMobile
    ? "min(80vw, 360px)"
    : "clamp(280px, 30vw, 380px)";

  if (allRelatedJobs.length === 0) return null;

  return (
    <section aria-labelledby="similar-jobs-heading">
      <div
        style={{
          paddingLeft: isMobile
            ? theme.spacing.contentElementPadding
            : theme.spacing.contentPaddingBig,
          paddingRight: isMobile
            ? theme.spacing.contentElementPadding
            : theme.spacing.contentPaddingBig,
          marginTop: theme.spacing.contentElementPadding,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: theme.spacing.elementPadding,
          }}
        >
          <AppText.BodyText
            id="similar-jobs-heading"
            use="h2"
            fontWeight={600}
          >
            {t("jobdetail.similar_jobs.title", {
              count: allRelatedJobs.length,
            })}
          </AppText.BodyText>

          <div
            style={{
              display: "flex",
              gap: theme.spacing.elementPadding,
            }}
          >
            <Button
              aria-label={t("jobdetail.similar_jobs.previous")}
              circular
              icon
              size="large"
              onClick={() => scroll(-1)}
              style={{
                backgroundColor: theme.colors.lightGrey,
                color: "#fff",
              }}
            >
              <Icon name="arrow left" />
            </Button>
            <Button
              aria-label={t("jobdetail.similar_jobs.next")}
              circular
              icon
              size="large"
              onClick={() => scroll(1)}
              style={{
                backgroundColor: theme.colors.lightGrey,
                color: "#fff",
              }}
            >
              <Icon name="arrow right" />
            </Button>
          </div>
        </div>
      </div>

      <div
        ref={scrollContainerRef}
        style={{
          display: "flex",
          overflowX: "auto",
          marginTop: theme.spacing.elementPadding,
          paddingLeft: isMobile
            ? theme.spacing.elementPadding
            : theme.spacing.contentPaddingBig,
          paddingRight: isMobile
            ? theme.spacing.elementPadding
            : theme.spacing.contentPaddingBig,
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          scrollBehavior: "smooth",
          scrollSnapType: "x mandatory",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: theme.spacing.contentElementPadding,
          }}
        >
          {allRelatedJobs.map((job) => (
            <div
              key={job.jobId}
              data-testid={`related-job-card-${job.jobId}`}
              style={{
                flex: `0 0 ${cardWidth}`,
                minWidth: 0,
                height: "100%",
                scrollSnapAlign: "start",
                marginBottom: theme.spacing.contentPadding,
              }}
            >
              <JobCard jobData={job} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
